export default {"src":"/_next/static/media/repv2.ffb836ea.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};